import Pane from 'components/Common/Pane'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import TextButton from 'LuxKit/Button/TextButton'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import Typography from 'LuxKit/Typography/Typography'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { useAppSelector } from 'hooks/reduxHooks'
import { rem } from 'polished'
import React, { useMemo } from 'react'
import styled from 'styled-components'
import LoyaltyLandingPageLargeTile from './LoyaltyLandingPageLargeTile'
import LoyaltyLandingPageSmallTile from './LoyaltyLandingPageSmallTile'
import LoyaltyLandingPageNextTierBenefitsContent from '../loyaltyUserAccountPage/LoyaltyLandingPageNextTierBenefitsContent'
import determineNextLoyaltyTier from 'loyalty/lib/determineNextLoyaltyTier'
import useLoyaltyLandingPageBenefitCopy from 'loyalty/hooks/useLoyaltyLandingPageBenefitCopy'
import { EmptyArray } from 'lib/array/arrayUtils'

const BenefitsSection = styled(Pane)`
  padding: ${rem(24)} 0;

  ${mediaQueryUp.tablet} {
    padding: ${rem(68)} 0;
  }
`

const SmallTilesSection = styled.div`
  display: grid;
  gap: ${rem(24)};

  ${mediaQueryUp.tablet} {
    grid-template-columns: repeat(3, 1fr);
  }
`

interface Props {
  onActivate?: () => void
}

function LoyaltyUserSilverBenefits(props: Props) {
  const { onActivate } = props

  const isLoyaltyMember = useAppSelector(state => !!state.loyalty.account.data)
  const nextTier = useMemo(() => determineNextLoyaltyTier('silver'), [])

  const [loyaltyLandingPageBenefitTiles] = useLoyaltyLandingPageBenefitCopy()

  const smallTiles = useMemo(() => {
    if (!loyaltyLandingPageBenefitTiles) return EmptyArray
    return [
      loyaltyLandingPageBenefitTiles.phone_support,
      loyaltyLandingPageBenefitTiles.travelshoot_credit,
      loyaltyLandingPageBenefitTiles.tour_exp_credit,
    ].filter(tile => tile?.enabled)
  }, [loyaltyLandingPageBenefitTiles])

  return <BenefitsSection background="neutral-seven">
    <VerticalSpacer gap={48}>
      <VerticalSpacer gap={8}>
        <Heading variant="heading2" align="center">
          Your Silver benefits, ready when you are
        </Heading>
        {!isLoyaltyMember && <BodyText variant="large" align="center">
          Activate your membership toady to get instant access to these benefits
        </BodyText>}
      </VerticalSpacer>
      {loyaltyLandingPageBenefitTiles?.hotel_upgrade?.enabled && <LoyaltyLandingPageLargeTile
        tile={loyaltyLandingPageBenefitTiles.hotel_upgrade}
        onActivate={onActivate}
      />}
      {loyaltyLandingPageBenefitTiles?.lounge_pass?.enabled && <LoyaltyLandingPageLargeTile
        tile={loyaltyLandingPageBenefitTiles.lounge_pass}
        reverse
      />}
      <SmallTilesSection>
        {smallTiles.map(tile => <LoyaltyLandingPageSmallTile
          key={tile.image.id}
          tile={tile}
        />)}
      </SmallTilesSection>
      <VerticalSpacer gap={24}>
        {nextTier && <LoyaltyLandingPageNextTierBenefitsContent nextTier={nextTier} />}
        {onActivate && <Typography align="center">
          <TextButton kind="primary" onClick={onActivate}>
            Activate your free membership
          </TextButton>
        </Typography>}
      </VerticalSpacer>
    </VerticalSpacer>
  </BenefitsSection>
}

export default LoyaltyUserSilverBenefits
